export default __webpack_public_path__ + "static/media/invite_interpreters.427ace69.svg";